'use client';

import { useEffect } from 'react';
import { ContentfulLivePreview } from '@contentful/live-preview';
export default function LivePreview() {
  useEffect(() => {
    ContentfulLivePreview.init({
      locale: 'en',
      debugMode: true,
      enableLiveUpdates: true
    });
    ContentfulLivePreview.subscribe('save', {
      callback: () => console.log('saved')
    });
    // TODO: Implement cache revalidation on save
  }, []);
  return null;
}